(function($) {
    //add Element Actions on elementor init
    $(window).on('elementor/frontend/init', function() {


        function add_order(){
            $('.od-fav-item').each(function(element) {
                var fav_order = $( this ).find('.od-order').text();
                var fav_order_number = fav_order.replace(/\D/g, '');
                var fav_order_final = fav_order_number.slice(0, 2) + fav_order_number.slice(8);
                $( this ).css({'order' : fav_order_final});
            });
        } setTimeout(add_order, 4000);
        

        elementorFrontend.hooks.addAction( 'frontend/element_ready/form.default', function($scope){
            $scope.find('input, textarea').focus(function(e) {
                var name = $(this).attr('id');
                if ($(this).val()) {
                    $('label[for="' + name + '"]').addClass('active');
                }
                if ($('label[for="' + name + '"]').length > 0) {
                    $('label[for="' + name + '"]').addClass('active');
                }
            });

            $scope.find('input, textarea').blur(function(e) {
                var name = $(this).attr('id');
                if ($('label[for="' + name + '"]').length > 0) {
                    $('label[for="' + name + '"]').removeClass('active');
                }
                if ($(this).val()) {
                    $('label[for="' + name + '"]').addClass('active');
                }
            });




            // Anmeldeform

            // Mittagessen Freitag
            function changeFunction_essen_fr(){
                var fleisch_fr = $('#form-field-essen_fleisch_fr').val();
                var veg_fr = $('#form-field-essen_veg_fr').val();
                $('#fr_eat_count').html(Number(fleisch_fr)+Number(veg_fr));
            }
            $('#form-field-essen_fleisch_fr, #form-field-essen_veg_fr').change(function (){
                changeFunction_essen_fr();
            });
            changeFunction_essen_fr();

            // Mittagessen Samstag
            function changeFunction_essen_sa(){
                var fleisch_sa = $('#form-field-essen_fleisch_sa').val();
                var veg_sa = $('#form-field-essen_veg_sa').val();
                $('#sa_eat_count').html(Number(fleisch_sa)+Number(veg_sa));
            }
            $('#form-field-essen_fleisch_sa, #form-field-essen_veg_sa').change(function (){
                changeFunction_essen_sa();
            });
            changeFunction_essen_sa();

            // Solo Zusammenfassung füllen

            function changeSolodataFunction() {
                $('.od-signin-form--solo .elementor-field-group-step_three .e-form__buttons__wrapper__button-next').click(function (){

                    if ($('#form-field-check_dauerkarten-0').is(':checked')){ var qty_dauerkarten = 1; } else { var qty_dauerkarten = 0; }
                    $('#counter_dauerkarten').html(Number(qty_dauerkarten));
                    if ($('#form-field-check_zwei_tageskarten-0').is(':checked')){ var qty_zwei_tageskarten = 1; } else { var qty_zwei_tageskarten = 0; }
                    $('#counter_2_tageskarten').html(Number(qty_zwei_tageskarten));
                    if ($('#form-field-check_tageskarte_fr-0').is(':checked')){ var qty_tageskarte_fr = 1; } else { var qty_tageskarte_fr = 0; }
                    $('#counter_tageskarte_fr').html(Number(qty_tageskarte_fr));
                    if ($('#form-field-check_tageskarte_sa-0').is(':checked')){ var qty_tageskarte_sa = 1; } else { var qty_tageskarte_sa = 0; }
                    $('#counter_tageskarte_sa').html(Number(qty_tageskarte_sa));

                    var radio_ubernachtung = $('input[name="form_fields[tag_ubernachtung_tageskarte]"]:checked + label').text();
                    $('#counter_ubernachtung').html(radio_ubernachtung);

                    var price_dauerkarten = 25*Number(qty_dauerkarten);
                    var price_zwei_tageskarten = 12.5*Number(qty_zwei_tageskarten);
                    var price_tageskarten = 7.5*(Number(qty_tageskarte_fr)+Number(qty_tageskarte_sa));
                    $('#counter_tickets_result').html(numberFormat(Number(price_dauerkarten)+Number(price_zwei_tageskarten)+Number(price_tageskarten)));

                    var einzel_name = $('#form-field-einzel_name').val();
                    $('#einzel_name').html(einzel_name);
                    var einzel_geburtstag = $('#form-field-einzel_geburtstag').val();
                    $('#einzel_geburtstag').html(einzel_geburtstag);
                    var einzel_email = $('#form-field-einzel_email').val();
                    $('#einzel_mail').html(einzel_email);
                    var einzel_strasse = $('#form-field-einzel_strasse').val();
                    var einzel_nummer = $('#form-field-einzel_nummer').val();
                    var einzel_plz = $('#form-field-einzel_plz').val();
                    var einzel_ort = $('#form-field-einzel_ort').val();
                    $('#einzel_adresse').html(einzel_name + "<br>" + einzel_strasse + " " + einzel_nummer + "<br>" +  einzel_plz + " " + einzel_ort);

                    $('#form-field-hidden_price_all').val(numberFormat(Number(price_dauerkarten)+Number(price_zwei_tageskarten)+Number(price_tageskarten)));

                    if ($('#form-field-alter-0').is(':checked')){
                        $('.elementor-field-group-einzel_upload').remove();
                    }

                    function numberFormat(value) {
                        if (typeof value !== "number") {
                            return value;
                        }
                        var formatter = new Intl.NumberFormat('de-DE', {
                            style: 'currency',
                            currency: 'EUR',
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                        });
                        return formatter.format(value);
                    }
                });
            }
            setTimeout(changeSolodataFunction, 2000);


            // Gruppe Zusammenfassung füllen

            function changeDataFunction() {
                $('.od-signin-form--group .elementor-field-group-step_four .e-form__buttons__wrapper__button-next').click(function (){


                    var qty_dauerkarten = $('#form-field-qty_dauerkarten').val();
                    $('#counter_dauerkarten').html(Number(qty_dauerkarten));
                    var qty_zwei_tageskarten = $('#form-field-qty_zwei_tageskarten').val();
                    $('#counter_2_tageskarten').html(Number(qty_zwei_tageskarten));
                    var qty_tageskarte_fr = $('#form-field-qty_tageskarte_fr').val();
                    $('#counter_tageskarte_fr').html(Number(qty_tageskarte_fr));
                    var qty_tageskarte_sa = $('#form-field-qty_tageskarte_sa').val();
                    $('#counter_tageskarte_sa').html(Number(qty_tageskarte_sa));
                    var radio_ubernachtung = $('input[name="form_fields[tag_ubernachtung_tageskarte]"]:checked + label').text();
                    $('#counter_ubernachtung').html(radio_ubernachtung);

                    var price_dauerkarten = 25*Number(qty_dauerkarten);
                    var price_zwei_tageskarten = 12.5*Number(qty_zwei_tageskarten);
                    var price_tageskarten = 7.5*(Number(qty_tageskarte_fr)+Number(qty_tageskarte_sa));
                    $('#counter_tickets_result').html(numberFormat(Number(price_dauerkarten)+Number(price_zwei_tageskarten)+Number(price_tageskarten)));

                    var radio_rallye = $('input[name="form_fields[rallye_tag]"]:checked + label').text();
                    $('#counter_rallye_tag').html(radio_rallye);
                    var qty_rallye = $('#form-field-qty_rallye').val();
                    $('#counter_rallye').html(Number(qty_rallye));

                    var qty_schal = $('#form-field-qty_schal').val();
                    $('#counter_schals').html(Number(qty_schal));
                    var price_schal = 1*Number(qty_schal);
                    $('#counter_schals_result').html(numberFormat(Number(price_schal)));

                    var price_all = Number(price_schal)+Number(price_dauerkarten)+Number(price_zwei_tageskarten)+Number(price_tageskarten);
                    $('#counter_all_result').html(numberFormat(Number(price_all)));

                    var essen_veg_fr = $('#form-field-essen_veg_fr').val();
                    $('#counter_veg_fr').html(Number(essen_veg_fr));
                    var fr_eat_count_all = $('#form-field-essen_fleisch_fr').val();
                    $('#fr_eat_count_2').html(Number(fr_eat_count_all)+Number(essen_veg_fr));
                    var essen_veg_sa = $('#form-field-essen_veg_sa').val();
                    $('#counter_veg_sa').html(Number(essen_veg_sa));
                    var sa_eat_count_all = $('#form-field-essen_fleisch_sa').val();
                    $('#sa_eat_count_2').html(Number(sa_eat_count_all)+Number(essen_veg_sa));
                    var price_eat = 3.5*(Number(sa_eat_count_all)+Number(fr_eat_count_all)+Number(essen_veg_fr)+Number(essen_veg_sa));
                    $('#counter_eat_result').html(numberFormat(Number(price_eat)));

                    var gl_name = $('#form-field-gl_name').val();
                    $('#gl_name').html(gl_name);
                    var gl_tel = $('#form-field-gl_tel').val();
                    $('#gl_tel').html(gl_tel);
                    var gl_email = $('#form-field-gl_email').val();
                    $('#gl_mail').html(gl_email);
                    var gl_institution = $('#form-field-gl_institution').val();
                    var gl_vorname = $('#form-field-gl_vorname').val();
                    var gl_nachname = $('#form-field-gl_nachname').val();
                    var gl_strasse = $('#form-field-gl_strasse').val();
                    var gl_nummer = $('#form-field-gl_nummer').val();
                    var gl_plz = $('#form-field-gl_plz').val();
                    var gl_ort = $('#form-field-gl_ort').val();
                    $('#gl_adresse').html(gl_institution + "<br>" + gl_vorname + " " + gl_nachname + "<br>" + gl_strasse + " " + gl_nummer + "<br>" +  gl_plz + " " + gl_ort);

                    var ap_1_name = $('#form-field-ap_1_name').val();
                    var ap_1_tel = $('#form-field-ap_1_tel').val();
                    $('#ap_1').html(ap_1_name + ", " + ap_1_tel);
                    var ap_2_name = $('#form-field-ap_2_name').val();
                    var ap_2_tel = $('#form-field-ap_2_tel').val();
                    $('#ap_2').html(ap_2_name + ", " + ap_2_tel);
                    var ap_3_name = $('#form-field-ap_3_name').val();
                    var ap_3_tel = $('#form-field-ap_3_tel').val();
                    $('#ap_3').html(ap_3_name + ", " + ap_3_tel);
                    var ap_4_name = $('#form-field-ap_4_name').val();
                    var ap_4_tel = $('#form-field-ap_4_tel').val();
                    $('#ap_4').html(ap_4_name + ", " + ap_4_tel);

                    var hidden_price_cards = Number(price_dauerkarten)+Number(price_zwei_tageskarten)+Number(price_tageskarten);
                    $('#form-field-hidden_price_cards').val(numberFormat(Number(hidden_price_cards)));
                    $('#form-field-hidden_price_schal').val(numberFormat(Number(price_schal)));
                    $('#form-field-hidden_price_all').val(numberFormat(Number(price_all)));

                    function numberFormat(value) {
                        if (typeof value !== "number") {
                            return value;
                        }
                        var formatter = new Intl.NumberFormat('de-DE', {
                            style: 'currency',
                            currency: 'EUR',
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                        });
                        return formatter.format(value);
                    }
                });
            }
            setTimeout(changeDataFunction, 2000);

        });

        elementorFrontend.hooks.addAction( 'frontend/element_ready/n1-custom-swiper.default', function($scope){
            var thisSwipterId = $scope.find('.swiper-container').attr('id');
            var swiper = new Swiper('#'+thisSwipterId, {
                slidesPerView: 'auto',
                spaceBetween: 24,
                centeredSlides: false,
                loop: false,
                pagination: {
                    el: '#'+thisSwipterId + ' .swiper-pagination',
                    clickable: true,
                },
                navigation: {
                    nextEl: '#'+thisSwipterId + ' .swiper-button-next',
                    prevEl: '#'+thisSwipterId + ' .swiper-button-prev',
                },
            });
        });


        elementorFrontend.hooks.addAction( 'frontend/element_ready/accordion.default', function($scope){
            var delay = 100; setTimeout(function() {
                $('.elementor-tab-title').removeClass('elementor-active');
                $('.elementor-tab-content').css('display', 'none');
            }, delay);

            $( ".accordion-close" ).click(function() {
                $('.elementor-tab-title').removeClass('elementor-active');
                $('.elementor-tab-content').css('display', 'none');
            });
        });


        $('.od-back-btn').on('click', function() {
            window.history.go(-1);
            return false;
        });
    });
}(jQuery));
